// Date 2020-11-20 16:17:08

import emSppSparePartsCatSpc from "@/store/em/spareparts/EmSppSparePartsCatSpcStore.js";
import emSppSparePartsSpa from "@/store/em/spareparts/EmSppSparePartsSpaStore.js";
import emSppStorageCatSsc from "@/store/em/spareparts/EmSppStorageCatSscStore.js";
import emSppStorageSst from "@/store/em/spareparts/EmSppStorageSstStore.js";
import emSppPurchaseStatePus from "@/store/em/spareparts/EmSppPurchaseStatePusStore.js";
import emSppInvChangeTypeIct from "@/store/em/spareparts/EmSppInvChangeTypeIctStore.js";
import emSppInventoryChangeIch from "@/store/em/spareparts/EmSppInventoryChangeIchStore.js";
import emSppStorageInfoSti from "@/store/em/spareparts/EmSppStorageInfoStiStore.js";
import emSppRequisitionSpr from "@/store/em/spareparts/EmSppRequisitionSprStore.js";
import emSppRequisitionDetSrd from "@/store/em/spareparts/EmSppRequisitionDetSrdStore.js";
import emSppWarehousingSpw from "@/store/em/spareparts/EmSppWarehousingSpwStore.js";
import emSppWarehousingDetSwd from "@/store/em/spareparts/EmSppWarehousingDetSwdStore.js";
import emSppLocation from "@/store/em/spareparts/EmSppLocationStore.js";
import emSppWarehouseMgr from "@/store/em/spareparts/EmSppWarehouseMgrStore.js";
import emSppSource from "@/store/em/spareparts/EmSppSourceStore.js";
import emSppAttribute from "@/store/em/spareparts/EmSppAttributeStore.js";
import emSppStorageLoc from "@/store/em/spareparts/EmSppStorageLocStore.js";
import emSppUnitSpu from "@/store/em/spareparts/EmSppUnitSpuStore.js";
import emSppRequisitionRwoSrr from "@/store/em/spareparts/EmSppRequisitionRwoSrrStore.js";
import emSparePartsInventorySpi from "@/store/em/spareparts/EmSparePartsInventorySpiStore.js";
import emSparePartsInventoryCheckSic from "@/store/em/spareparts/EmSparePartsInventoryCheckSicStore.js";

const genericEntities = [
    'emSppSource',
    'emSppAttribute',
    'emSppSparePartsCatSpc',
    'emSppSparePartsSpa',
    'emSppStorageCatSsc',
    'emSppStorageSst',
    'emSppStorageLoc',
    'emSppLocation',
    'emSppWarehouseMgr',
    'emSppPurchaseStatePus',
    'emSppInvChangeTypeIct',
    'emSppInventoryChangeIch',
    'emSppStorageInfoSti',
    'emSppRequisitionSpr',
    'emSppRequisitionDetSrd',
    'emSppWarehousingSpw',
    'emSppWarehousingDetSwd',
    'emSppUnitSpu',
    'emSppRequisitionRwoSrr',
    'emSparePartsInventorySpi',
    'emSparePartsInventoryCheckSic'

]

const entities = {
    emSppSource,
    emSppAttribute,
    emSppSparePartsCatSpc,
    emSppSparePartsSpa,
    emSppStorageCatSsc,
    emSppStorageSst,
    emSppStorageLoc,
    emSppLocation,
    emSppWarehouseMgr,
    emSppPurchaseStatePus,
    emSppInvChangeTypeIct,
    emSppInventoryChangeIch,
    emSppStorageInfoSti,
    emSppRequisitionSpr,
    emSppRequisitionDetSrd,
    emSppWarehousingSpw,
    emSppWarehousingDetSwd,
    emSppUnitSpu,
    emSppRequisitionRwoSrr,
    emSparePartsInventorySpi,
    emSparePartsInventoryCheckSic

}

export {genericEntities}

export default entities
